export enum TimesEnum {
    HOURS = 'hours',
    MINUTES = 'minutes',
    SECONDS = 'seconds',
    FIRST_RESPONSE_MINUTES = 'firstResponseMinutes',
    FIRST_RESPONSE_SECONDS = 'firstResponseSeconds'
}
export const validateTime = ({ name, newValue, oldValue, }: { name?: TimesEnum; oldValue: number; newValue: number }): number => {
    switch (name) {
        case TimesEnum.HOURS: {
            return newValue > 23 ? oldValue : newValue
        }
        case TimesEnum.FIRST_RESPONSE_MINUTES:
        case TimesEnum.FIRST_RESPONSE_SECONDS:
        case TimesEnum.SECONDS:
        case TimesEnum.MINUTES: {
            return newValue > 59 ? oldValue : newValue
        }
        default: return newValue
    }
}